import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useField } from '@unform/core';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { FaTimes } from 'react-icons/fa'
;import { Container, Error } from './styles';

const AuthInput = ({ name = 'name', icon: Icon, ...rest }) => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { fieldName, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);

  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    })
  }, [fieldName, registerField])

  return (
    <Container isErroded={!!error} isFilled={isFilled} isFocused={isFocused}>

      <input
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        ref={inputRef}
        onChange={(e) => setIsFilled(true)}
        type={isVisible ? 'text' : 'password'}
        {...rest}
      />


      {(error && !isFilled) && (
        <Error isFocused={isFocused}>
          <FaTimes size={24} color="#dc3545"/>
          <span>{error}</span>

        </Error>
      )}

      {Icon && (
        <button type="button" className="eye-container" onClick={() => setIsVisible(!isVisible)}>
          {isVisible ? (

            <BsEye size={20} />
          ) : (
            <BsEyeSlash size={20}  />
          )}

        </button>
      )}


    </Container>
  );
}

export default AuthInput;
